import {
  Button,
  LabeledInput,
  LabeledSelect,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@apexinternal/ui-components'
import { Stack } from '@chakra-ui/react'
import { values } from 'lodash'
import React, { useState } from 'react'
import { AccountStatus, AccountStatusDisplay } from '../../../../types'

export interface EditModalContentProps {
  accountStatus: AccountStatus
  reason: string
  setAccountStatus: (accountStatus: AccountStatus) => void
  setReason: (reason: string) => void
  onClose: () => void
  onConfirm: () => void
}

const EditModalContent = ({
  accountStatus,
  reason,
  setAccountStatus,
  setReason,
  onClose,
  onConfirm,
}: EditModalContentProps) => {
  const [reasonTouched, setReasonTouched] = useState(false)

  const isReasonEmpty = !reason.trim()
  const isInvalid = reasonTouched && isReasonEmpty
  const hasError = isReasonEmpty
  return (
    <ModalContent>
      <ModalHeader>Third Party Trading Access</ModalHeader>
      <ModalCloseButton onClick={onClose} />
      <ModalBody>
        <Stack spacing="1rem">
          <LabeledSelect
            width="12rem"
            isRequired
            label="Trading Access"
            value={accountStatus}
            onChange={e => setAccountStatus(e.target.value as AccountStatus)}
            tabIndex={1}
          >
            {values(AccountStatus).map(accountStatusValue => (
              <option key={accountStatusValue} value={accountStatusValue}>
                {AccountStatusDisplay[accountStatusValue]}
              </option>
            ))}
          </LabeledSelect>
          <LabeledInput
            errorMessage={isInvalid ? 'Required' : undefined}
            isInvalid={isInvalid}
            isRequired
            charCounter={255}
            maxLength={255}
            label="Restriction Reason"
            value={reason}
            onBlur={() => setReasonTouched(true)}
            onChange={e => setReason(e.target.value)}
            tabIndex={2}
          />
        </Stack>
      </ModalBody>
      <ModalFooter>
        <Stack direction="row" spacing={2}>
          <Button variant="white" onClick={onClose} tabIndex={3}>
            Cancel
          </Button>
          <Button
            variant="primary"
            isDisabled={hasError}
            onClick={onConfirm}
            tabIndex={4}
          >
            Confirm Changes
          </Button>
        </Stack>
      </ModalFooter>
    </ModalContent>
  )
}

export default EditModalContent
